import ProductLayout from '../ProductLayout'

const WePlane = ({ isConnected }: { isConnected: boolean }) => {
  return <ProductLayout isConnected={isConnected} productName="WePlane" biReportNames={['Planing', 'Rabotage']} />
}

export default WePlane
